import http from '@/utils/http'
const AccumActType = 102
export default {
  collectReward: (params) => {
    return http.post('/json/activity/collectReward', { ...params, activityType: AccumActType })
  },
  oneKeyCollect: (params) => {
    return http.post('/json/activity/oneKeyCollect', { ...params, activityType: AccumActType })
  },
  getRewardRecordList: (params) => {
    return http.post('/json/activity/rewardRecordList', { ...params, activityType: AccumActType })
  },
  getRewardList: (params) => {
    return http.post('/json/activity/rewardList', { ...params, activityType: AccumActType })
  },
}


